import React from 'react';
import { observer } from 'mobx-react-lite';
import HelperCore from '@src/common/helper/core.js';

const CardAudio = observer((props) => {
  const {
    data,
    event,
  } = props;
  let item = {};
  if (data && typeof data === 'string') {
    item = {
      url: data
    }
  }
  else if(event?.detail?.results?.length){
    item = event.detail.results[0];
  } 
  else {
    item = data?.[0] ?? {}
  }

  return (
    <>
      <div className="size-full flex items-center justify-center px-24px py-16px flex-wrap pb-76px">
        <div className="flex-basis-[100%] flex justify-center">
          <img src={item?.icon || 'https://p1.ssl.qhimg.com/t110b9a9301d3eec63bac678504.png'} className='w-80px h-80px rounded-8px'/>
        </div>
        <div className="flex-basis-[100%] w-100% flex justify-center mt-16px">
          <span className='truncate'>{item?.title || '--'}</span>
        </div>
        <div className="flex-basis-[100%] flex justify-center mb-16px">
          <span>{Number.parseFloat((item?.file_size || 0)/1024/1024, 2).toFixed(2) + ' MB'}</span>
        </div>
        <div className="flex-basis-[100%] flex justify-center">
          <audio className="object-contain max-w-full max-h-full w-full" controls preload="metadata" src={item?.url}></audio>
        </div>
      </div>
    </>
  )
});

export default CardAudio;